import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { POTICNewRequestComponent } from './new-request/new-request.component';
import { PropertyOccupancyTechnicalInstallationConsentRoutingModule } from './property-occupancy-technical-installation-consent-routing.module';
import { PropertyOccupancyTechnicalInstallationConsentComponent } from './property-occupancy-technical-installation-consent.component';
import { POTICNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [
    PropertyOccupancyTechnicalInstallationConsentComponent,
    POTICNewRequestComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    PropertyOccupancyTechnicalInstallationConsentRoutingModule,
    MatSelectModule,
  ],
  providers: [POTICNewRequestFormService],
})
export class PropertyOccupancyTechnicalInstallationConsentModule {}
